<template lang="html">
	<div class="form">
		<!-- {{data}} -->

		<div class="relContainer">
			<label class="phone">
				<input type="tel"
				v-model='phone'
				:placeholder='field2.placeholder'>
				<span class="validation-error" :error='errors.required.phone'>
					<span class="required">{{field2.validator}}</span>
				</span>
			</label>

			<button @click='click'></button>
		</div>

		<grecaptcha
			:request='request'
			:payload='payload'
			@SENDFORM='onRecaptchaSubmit'
		/>
	</div>
</template>

<script>
const Inputmask = require('inputmask');

module.exports = {
	name: 'header-callback',

	props: {
		data: {
			type: Object,
			required: true
		}
	},

	components: {
		grecaptcha: require('./elements/grecaptcha.vue'),
	},

	data() {
		return {
			phone: '',

			completePhone: false,

			errors: {
				required: {
					phone: false
				}
			},
			grcID: null,

			payload: {}
		}
	},

	computed: {
		field2() {
			return this.data.fields ? this.data.fields[0] : {};
		},

		request() {
			return this.data ? this.data.request : {};
		},

		request() {
			return this.data ? this.data.request : {};
		}
	},


	methods: {
		onRecaptchaSubmit(payload) {
			this.$emit('SENDFORM', payload);
		},
		click() {
			// console.log(this);
			if(this.completePhone) {
				this.payload = {
					[this.field2.name]: this.phone
				}
			}
			else {
				if(!this.completePhone) {
					this.errors.required.phone = true;
				}
			}
		}
	},



	mounted() {

		let phone = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.tel.default,
			definitions: {
				'9': '',
				'x': {
					validator: "[0-9\\s]",
					cardinality: 1,
					casing: "lower"
				}
			},
			oncomplete: () => {
				console.log('tel oncomplete');
				this.completePhone = true;
				this.showRequiredPhone = false;
			},
			onincomplete: () => {
				console.log('tel oncomplete');
				this.completePhone = false;
			},
			oncleared: () => {
				console.log('tel oncleared');
				this.completePhone = false;
			}
		});

		phone.mask(this.$el.querySelector('.phone input'));

		this.$parent.$on('clear', () => {
			this.name = '';
			this.phone = this.field2.value;
			console.log(this.phone);
		})

		this.$on('clear', () => {
			this.phone = this.field2.value;
		})

		let timerid = setTimeout(() => {
		  this.$emit('clear'); 
	  }, 1000);
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.VForm.header-callback {

	margin-bottom: 13px;

	[grecaptcha] {
		display: none;
	}

	.form {
		.relContainer{
			position: relative;
			label {
				margin: 0;
				display: block;
				position: relative;;

				input {
					display: block;
					height: rem(57);
					width: 100%;
					border: 1px solid #de4b39;
					padding: 0 20px;
					background-color: transparent;
					border-radius: 10px;
					text-align: left;
					color: #de4b39;
					@include placeholder {
						color: #de4b39;
						opacity: 1;
					};
				}

				.validation-error {
					position: absolute;
					left: 30px;
					right: 30px;
					font-size: 12px;
					color: #de4b39;
					display: block;
					text-align: center;
					@include s_up {
						top: 44px;
					};
					@include m_up {
						left: 0;
						right: 0;
						top: calc(100% + 5px);
					};
					@include m___up {
						left: 10px;
						right: 30px;
						text-align: left;
					};


					&[error] .required {
						opacity: 1;
						transform: translateY(0px);
					}

					.required {
						display: block;
						transform: translateY(5px);
						opacity: 0;
						@include single-transition;
					}
				}
			}

			button {
				position: absolute;
				top: 1px;
				right: 1px;
				border-radius: 10px;
				height: rem(55);
				width: 45px;
				background-image: url('#{$imgPathSCSS}arrow-right.png');
				background-repeat: no-repeat;
				background-position: calc(100% - 19px) center;
				cursor: pointer;
				@include single-transition;
				background-color: transparent;
				border: none;
				&:hover{
					background-color: transparent;
				}

			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// header-callback.vue?cc5cac7c